// https://kazupon.github.io/vue-i18n/guide/lazy-loading.html

import axios from 'axios'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import YAML from 'yamljs'
// The english lang is hardcoded into the bundle. Other langs will
// be fetched from the server instead of import()'ed, so I don't
// have to resubmit the extension everytime a lang is updated.
import en from '@/assets/locales/en.yaml'
//import { Sentry } from '@common/sentry'

const cl = console.log

Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: { en }
})

const supportedLanguages = process.env.SUPPORTED_LOCALES
const loadedLanguages = ['en']
// Ignore country specific locales for now, like en-US, en-GB.
const toBaseLang = lang => lang.split('-')[0]

function setI18nLanguage (lang) {
    i18n.locale = lang
    return lang
}

export function detectLanguage () {
    for (let lang of navigator.languages) {
        lang = toBaseLang(lang)

        if (supportedLanguages.includes(lang)) {
            return loadLanguageAsync(lang)
        }
    }
}

export async function loadLanguageAsync (lang) {
    lang = toBaseLang(lang)

    if (i18n.locale === lang) {
        return setI18nLanguage(lang)
    }

    if (loadedLanguages.includes(lang)) {
        return setI18nLanguage(lang)
    }

    if (!supportedLanguages.includes(lang)) {
        return setI18nLanguage('en')
    }

    // Locales is served directly by nginx, not from /api
    const url = `${process.env.EBS_ORIGIN}/locales/${lang}.yaml`
    const res = await axios.get(url)
    
    i18n.setLocaleMessage(lang, YAML.parse(res.data))
    loadedLanguages.push(lang)

    return setI18nLanguage(lang)
}
